export const COMMISSION_RATE_TYPE = {
  CPA: 'CPA', // CPA
  WS: 'WS', // Wager share
  RS: 'RS', // Revenue Share
  HY: 'HY', // Hybrid
};
